// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB2V-yOvBtxqnFXd8HnM6fEMEWo14qJLNM",
  authDomain: "chavatar-488b7.firebaseapp.com",
  projectId: "chavatar-488b7",
  storageBucket: "chavatar-488b7.firebasestorage.app",
  messagingSenderId: "746137250204",
  appId: "1:746137250204:web:a892a161e9d7f82abac059",
  measurementId: "G-8YTWNYGQ3W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and get a reference to the service
let analytics = null;

// Only initialize analytics in the browser environment
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { app, analytics };
